<form [formGroup]="zakelijkePartnersFg">
  <ng-container formArrayName="zakelijkePartners">
    @for (item of zakelijkePartners.controls; track trackByFn(i); let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="row flex-nowrap">
          <ng-container formGroupName="displayName">
            <snelstart-ui-text-form-control formControlName="value"
                                            [label]="i === 0 ? 'Zakelijke partner' : ''"
                                            id="displayName"
                                            class="me-1 custom-input-225 custom-readonly"
                                            [disabledControl]="true"
            >
            </snelstart-ui-text-form-control>
          </ng-container>
          <ng-container formGroupName="ondertekeningJaarrekening">
            <ng-container formGroupName="nameRepresentative">
              <snelstart-ui-text-form-control formControlName="value"
                                              [label]="i === 0 ? 'Naam ondertekenaar' : ''"
                                              id="nameRepresentative"
                                              class="me-1 custom-input-225"
                                              (change)="this.saveForm()">
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="representativeType">
              <snelstart-ui-select-form-control formControlName="value"
                                                class="me-1 custom-input-150"
                                                [label]="i === 0 ? 'Soort' : ''"
                                                [options]="this.optionsVerantwoordelijkeType"
                                                [required]=true
                                                (change)="saveForm()"
              >
              </snelstart-ui-select-form-control>
            </ng-container>
            <ng-container formGroupName="signatureRepresentativeLocation">
              <snelstart-ui-text-form-control formControlName="value"
                                              [label]="i === 0 ? 'Plaats ondertekening' : ''"
                                              id="signatureRepresentativeLocation"
                                              [required]=true
                                              class="me-1 custom-input-175"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-text-form-control>
            </ng-container>
            <ng-container formGroupName="signatureRepresentativeDate">
              <snelstart-ui-date-form-control formControlName="value"
                                              [label]="i === 0 ? 'Datum ondertekening' : ''"
                                              id="signatureRepresentativeDate"
                                              [required]=true
                                              class="me-1 custom-input-175"
                                              (change)="this.saveForm()"
              >
              </snelstart-ui-date-form-control>
            </ng-container>
            <ng-container formGroupName="representativeSignedStatus">
              <snelstart-ui-select-form-control formControlName="value"
                                                class="me-1 custom-input-125"
                                                [label]="i === 0 ? 'Ondertekend' : ''"
                                                [options]="this.optionsJaNee"
                                                [disabledControl]="true"
                                                (change)="saveForm()"
              >
              </snelstart-ui-select-form-control>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    }
  </ng-container>
</form>
